import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  constructor(
    private cookieService: CookieService
  ) { }

  ngOnInit(): void {
  }

  get game(){
    let game = this.cookieService.getObject('game') as {game:string};
    return game.game;
  }

}
